import { useTranslation } from "react-i18next";
import { CloudSlashIcon, WifiSlashIcon } from "@phosphor-icons/react";
import { useOnlineStatus } from "../../../hooks/use_online_status";
import useWindowBreakpoint from "../../../hooks/use_window_breakpoint";
import { useUserDataContext } from "../../../user_data_context";

const BASE_BANNER_CLASS = [
	"fixed inset-x-0 z-[9999]",
	"flex items-center justify-center gap-[6px]",
	"h-[28px] bg-[#f1b90c] text-black text-[13px] font-medium",
].join(" ");

const OfflineBanner = () => {
	const { t } = useTranslation();
	const isOnline = useOnlineStatus();
	// Online, but our server does not answer: the session is kept and the profile is being retried.
	const { authStatus } = useUserDataContext();
	const isServerUnreachable = authStatus === "unreachable";
	// Same 1024px breakpoint the site header switches on: narrow layouts put
	// navigation at the bottom of the screen, so the banner goes up top there —
	// wide layouts put navigation at the top (sidebar rail or guest top bar),
	// so the banner goes to the bottom instead, to never sit on top of it.
	const isNarrowLayout = useWindowBreakpoint(1024);

	if (isOnline && !isServerUnreachable) return null;

	return (
		<div
			className={`${BASE_BANNER_CLASS} ${isNarrowLayout ? "top-0" : "bottom-0"}`}
			role="status"
			data-testid="offline-banner"
		>
			{isOnline ? (
				<CloudSlashIcon size={15} weight="bold" />
			) : (
				<WifiSlashIcon size={15} weight="bold" />
			)}
			{t(
				isOnline
					? "common-components.server-unreachable-banner"
					: "common-components.offline-banner",
			)}
		</div>
	);
};

export default OfflineBanner;
